import AlbumInvite from 'Media/component/AlbumInvite.vue';
import ajax from 'Site/js/util/ajax.fetch';
import Avatar from 'Profile/component/Avatar.vue';
import AvatarPicker from 'Site/component/AvatarPicker.vue';
import collapseDirective from 'Site/directive/collapse';
import coverImageMixin from 'Site/js/mixin/cover.image';
import dropdownDirective from 'Site/directive/dropdown';
import openChatDirective from 'Site/directive/openChat';
import openMessengerDirective from 'Messenger/directive/openMessenger';
import EventInvite from 'Parties/component/EventInvite.vue';
import GroupInvite from 'Groups/component/GroupInvite.vue';
import Like from 'Feedback/component/Like.vue';
import ProfileHeaderActions from 'Profile/component/ProfileHeaderActions.vue';
import router from 'Profile/js/router';
import store from 'Site/js/store';
import Vouch from 'Profile/component/Vouch.vue';
import { mapActions, mapState } from 'vuex';

export default { /* eslint no-new:0 */
    el: '#profile-header-vue',
    name: 'ProfileHeader',
    router,
    store,
    components: {
        AlbumInvite,
        Avatar,
        AvatarPicker,
        EventInvite,
        GroupInvite,
        Like,
        ProfileHeaderActions,
        Vouch
    },
    computed: {
        ...mapState({
            config: state => state.config.data,
            isMobile: state => state.isMobile,
            t: state => state.t.profile
        }),
        editButtonText() {
            return this.editMode ? store.state.t.profile.edit_mode.disable : store.state.t.profile.edit_mode.enable;
        },
        profile() {
            if (!this.newAvatar) {
                /* @todo fix this */
                /* eslint vue/no-side-effects-in-computed-properties: 0 */
                this.config.profile.photos = null;
                return this.config.profile;
            }
            return Object.assign({}, this.config.profile, { avatar: this.newAvatar, photos: null });
        },
        avatarRotateStyle() {
            if (this.rotatePosition === 0) {
                return '';
            }
            return `transform: rotate(${this.rotatePosition}deg)`;
        }
    },
    data() {
        return {
            editMode: false,
            inviteModalTitle: '',
            inviteType: 'albumInvite',
            newAvatar: '',
            rotatePosition: 0,
            showAvatarModal: false,
            showInviteModal: false,
            showRotate: true,
            showRotateSave: false,
            showVouchModal: false,
            showVouchButton: true,
        };
    },
    directives: {
        dropdown: dropdownDirective,
        collapse: collapseDirective,
        openChat: openChatDirective,
        openMessenger: openMessengerDirective
    },
    methods: {
        ...mapActions(['notify', 'showMediaViewer']),
        changeAvatar() {
            this.showAvatarModal = true;
        },
        showVouch() {
            this.showVouchModal = true;
        },
        updateAvatar(newAvatar) {
            this.showAvatarModal = false;
            this.newAvatar = newAvatar;
            if (newAvatar.id) {
                ajax.update('avatar', { id: newAvatar.id }).then((response) => {
                    this.notify({ msg: response.message });
                });
            }
        },
        changeCoverImage(coverImage) {
            this.showCoverImageModal = false;
            this.coverImage = coverImage.url;
            if (coverImage.upload) {
                this.notify({ msg: this.$store.state.t.cover_image_awaiting_approval });
                return;
            }
            if (coverImage.site) {
                ajax.delete('cover', { id: this.config.userId });
                ajax.update('profile', { id: this.config.userId, theme: coverImage.name }).then((response) => {
                    this.notify({ msg: response.message });
                });
            } else {
                ajax.update('cover', { id: coverImage.id, user: this.config.userId }).then(() => {
                    this.notify({ msg: this.$store.state.t.cover_image_updated });
                });
            }
        },
        inviteToAlbum() {
            this.inviteType = 'albumInvite';
            this.$nextTick(() => {
                this.showInviteModal = true;
                this.inviteModalTitle = this.t.profile_header.album_invite;
            });
        },
        inviteToEvent() {
            this.inviteType = 'eventInvite';
            this.$nextTick(() => {
                this.showInviteModal = true;
                this.inviteModalTitle = this.t.profile_header.event_invite;
            });
        },
        inviteToGroup() {
            this.inviteType = 'groupInvite';
            this.$nextTick(() => {
                this.showInviteModal = true;
                this.inviteModalTitle = this.t.profile_header.group_invite;
            });
        },
        rotateAvatar() {
            this.rotatePosition += 90;
            if (this.rotatePosition === 360) {
                this.rotatePosition = 0;
                this.showRotateSave = false;
            } else {
                this.showRotateSave = true;
            }
            this.$refs.avatar.$el.querySelector('.profile-image-background').style = this.avatarRotateStyle;
        },
        saveRotateAvatar() {
            this.showRotateSave = false;
            this.showRotate = false;
            ajax.create('editphoto', [{ type: 'rotate', process: this.rotatePosition }]).then((response) => {
                this.notify({ msg: response.message });
            });
        },
        showAvatar() {
            if (this.config.avatarData && this.config.avatarData.media) {
                this.config.avatarData.user = this.config.profile;

                this.showMediaViewer({ media: [this.config.avatarData], start: 0 });
            }
        },
        toggleEditMode() {
            this.editMode = !this.editMode;
        }
    },
    mixins: [coverImageMixin]
};
